import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, A11y } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5000"
).replace(/\/+$/, "");

function BlogOne() {
  const [certificates, setCertificates] = useState([]);

  const [selectedCertificate, setSelectedCertificate] = useState(null);

  const [loading, setLoading] = useState(true);

  const getImageUrl = (imagePath) => {
    if (!imagePath || typeof imagePath !== "string") {
      return "";
    }

    const trimmedPath = imagePath.trim();

    if (
      trimmedPath.startsWith("http://") ||
      trimmedPath.startsWith("https://") ||
      trimmedPath.startsWith("data:") ||
      trimmedPath.startsWith("blob:")
    ) {
      return trimmedPath;
    }

    const cleanPath = trimmedPath.replace(/^\/+/, "");

    /*
     * Görsellerde /api kullanılmıyor.
     *
     * Örnek:
     * http://localhost:5000/cdn/dosya.webp
     */
    return `${API_BASE_URL}/cdn/${cleanPath}`;
  };

  useEffect(() => {
    const controller = new AbortController();

    const fetchCertificates = async () => {
      try {
        setLoading(true);

        const searchParams = new URLSearchParams(window.location.search);

        const currentLang = searchParams.get("lang") || "tr";

        const response = await fetch(
          `${API_BASE_URL}/api/blogs/gallery?lang=${encodeURIComponent(
            currentLang,
          )}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
            },
            signal: controller.signal,
          },
        );

        if (!response.ok) {
          throw new Error(`Sertifikalar alınamadı: ${response.status}`);
        }

        const rows = await response.json();

        /*
         * Her kaydın içindeki images dizisini
         * tek sertifika listesine dönüştürüyoruz.
         */
        const certificateList = Array.isArray(rows)
          ? rows.flatMap((row) => {
              const images = Array.isArray(row.images)
                ? row.images
                : row.image
                  ? [row.image]
                  : [];

              return images.filter(Boolean).map((imagePath, imageIndex) => ({
                id: `${row.id}-${imageIndex}`,
                recordId: row.id,
                title: row.title || `Sertifika ${imageIndex + 1}`,
                image: getImageUrl(imagePath),
              }));
            })
          : [];

        setCertificates(certificateList);
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("CERTIFICATE_API_ERROR:", error);

          setCertificates([]);
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    fetchCertificates();

    return () => {
      controller.abort();
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setSelectedCertificate(null);
      }
    };

    if (selectedCertificate) {
      document.body.style.overflow = "hidden";

      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      document.body.style.overflow = "";

      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedCertificate]);


  if (loading) {
    return null;
  }

  if (certificates.length === 0) {
    return null;
  }

  return (
    <div>
      <style>
        {`
          .demirsan-certificates {
            padding: 30px 0;
            background: #f7f7f7;
            overflow: hidden;
          }

          .certificate-title-area {
            margin-bottom: 45px;
            text-align: center;
          }

          .certificate-subtitle {
            margin: 0 0 10px;
            color: #df0a0a;
            font-size: 16px;
            font-weight: 600;
            line-height: 1.2;
          }

          .certificate-main-title {
            margin: 0;
            color: #1c2539;
            font-size: 42px;
            font-weight: 700;
            line-height: 1.2;
          }

          .certificate-swiper {
            padding: 10px 5px 55px;
          }

          .certificate-swiper .swiper-slide {
            height: auto;
          }

          .certificate-card {
            height: 100%;
            overflow: hidden;
            background: #ffffff;
            border: 1px solid #e7e7e7;
            border-radius: 10px;
            box-shadow:
              0 8px 25px
              rgba(0, 0, 0, 0.07);
            transition:
              transform 0.25s ease,
              box-shadow 0.25s ease;
          }

          .certificate-card:hover {
            transform: translateY(-6px);
            box-shadow:
              0 15px 35px
              rgba(0, 0, 0, 0.13);
          }

          .certificate-image-button {
            display: block;
            width: 100%;
            height: 100%;
            padding: 18px;
            border: 0;
            outline: 0;
            background: #ffffff;
            cursor: zoom-in;
          }

          .certificate-image-area {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 520px;
            overflow: hidden;
            background: #ffffff;
          }

          .certificate-image-area img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
            transition:
              transform 0.3s ease;
          }

          .certificate-card:hover
            .certificate-image-area img {
            transform: scale(1.02);
          }

          /*
           * Swiper okları
           */
          .certificate-swiper
            .swiper-button-prev,
          .certificate-swiper
            .swiper-button-next {
            width: 46px;
            height: 46px;
            margin-top: 0;
            border-radius: 50%;
            background: #df0a0a;
            box-shadow:
              0 8px 20px
              rgba(0, 0, 0, 0.16);
          }

          .certificate-swiper
            .swiper-button-prev {
            left: 5px;
          }

          .certificate-swiper
            .swiper-button-next {
            right: 5px;
          }

          .certificate-swiper
            .swiper-button-prev::after,
          .certificate-swiper
            .swiper-button-next::after {
            color: #ffffff;
            font-size: 17px;
            font-weight: 700;
          }

          /*
           * Büyük görsel modalı
           */
          .certificate-modal {
            position: fixed;
            inset: 0;
            z-index: 999999;

            display: flex;
            align-items: center;
            justify-content: center;

            padding: 30px;

            background:
              rgba(0, 0, 0, 0.88);
          }

          .certificate-modal-content {
            position: relative;

            display: flex;
            align-items: center;
            justify-content: center;

            width: auto;
            max-width: 95vw;
            height: auto;
            max-height: 92vh;
          }

          .certificate-modal-image {
            display: block;

            width: auto;
            max-width: 95vw;
            height: auto;
            max-height: 92vh;

            object-fit: contain;

            border-radius: 4px;
            background: #ffffff;
          }

       /*
|--------------------------------------------------------------------------
| MODAL AKSİYONLARI
|--------------------------------------------------------------------------
*/

.certificate-modal-actions {
  position: absolute;

  top: -18px;
  right: -18px;

  z-index: 5;

  display: flex;
  align-items: center;

  gap: 8px;
}


/*
|--------------------------------------------------------------------------
| ORTAK BUTON
|--------------------------------------------------------------------------
*/

.certificate-modal-close,
.certificate-modal-download {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  flex: 0 0 44px !important;

  width: 44px !important;
  min-width: 44px !important;
  max-width: 44px !important;

  height: 44px !important;
  min-height: 44px !important;
  max-height: 44px !important;

  margin: 0 !important;
  padding: 0 !important;

  border: 2px solid #ffffff !important;
  border-radius: 50% !important;

  color: #ffffff !important;

  line-height: 1 !important;

  cursor: pointer;
}


/*
|--------------------------------------------------------------------------
| İNDİR
|--------------------------------------------------------------------------
*/

.certificate-modal-download {
  background: #0b1735 !important;
}

.certificate-modal-download:hover {
  background: #263859 !important;
}


/*
|--------------------------------------------------------------------------
| KAPAT
|--------------------------------------------------------------------------
*/

.certificate-modal-close {
  background: #df0a0a !important;
}

.certificate-modal-close:hover {
  background: #b90000 !important;
}


/*
|--------------------------------------------------------------------------
| İKONLAR TAM ORTADA
|--------------------------------------------------------------------------
*/

.certificate-modal-close svg,
.certificate-modal-download svg {
  display: block !important;

  flex: none !important;

  width: 19px !important;
  height: 19px !important;

  margin: 0 !important;
  padding: 0 !important;

  transform: none !important;

  pointer-events: none;
}

          @media (
            max-width: 1199.98px
          ) {
            .certificate-image-area {
              height: 450px;
            }
          }

          @media (
            max-width: 991.98px
          ) {
            .demirsan-certificates {
              padding: 30px 0;
            }

            .certificate-image-area {
              height: 500px;
            }
          }

          @media (
            max-width: 767.98px
          ) {
            .demirsan-certificates {
              padding: 25px 0;
            }

            .certificate-title-area {
              margin-bottom: 30px;
            }

            .certificate-main-title {
              font-size: 34px;
            }

            .certificate-image-area {
              height: auto;
              min-height: 400px;
            }

            .certificate-image-area img {
              width: 100%;
              height: auto;
              max-height: 500px;
            }

            .certificate-modal {
              padding: 15px;
            }
.certificate-modal-actions {
  top: 5px;
  right: 5px;

  gap: 6px;
}

.certificate-modal-close,
.certificate-modal-download {
  flex-basis: 40px !important;

  width: 40px !important;
  min-width: 40px !important;
  max-width: 40px !important;

  height: 40px !important;
  min-height: 40px !important;
  max-height: 40px !important;
}

.certificate-modal-close svg,
.certificate-modal-download svg {
  width: 17px !important;
  height: 17px !important;
}
          }
.certificate-modal-content {
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 95vw;
  height: 92vh;

  max-width: none;
  max-height: none;
}

.certificate-modal-image {
  display: block;

  /* EKRANI REFERANS AL */
  width: 95vw;
  height: 92vh;

  max-width: none;
  max-height: none;

  /* Sertifikanın oranını BOZMA */
  object-fit: contain;

  border-radius: 4px;
  background: transparent;
}
        `}
      </style>

      <section
        className="rts-blog-area demirsan-certificates"
        id="certificates-section"
      >
        <div className="container">
          <div className="certificate-title-area">
            <p className="certificate-subtitle">BELGELERİMİZ</p>

            <h2 className="certificate-main-title">Sertifikalarımız</h2>
          </div>

          <Swiper
            className="certificate-swiper"
            modules={[Navigation, Autoplay, A11y]}
            slidesPerView={1}
            spaceBetween={24}
            speed={700}
            grabCursor
            watchOverflow
            navigation={certificates.length > 3}
            autoplay={
              certificates.length > 3
                ? {
                    delay: 3500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                  }
                : false
            }
            breakpoints={{
              768: {
                slidesPerView: 2,
                spaceBetween: 24,
              },
              992: {
                slidesPerView: 3,
                spaceBetween: 28,
              },
            }}
          >
            {certificates.map((certificate) => (
              <SwiperSlide key={certificate.id}>
                <div className="certificate-card">
                  <button
                    type="button"
                    className="certificate-image-button"
                    onClick={() => setSelectedCertificate(certificate)}
                    aria-label={`${certificate.title} sertifikasını büyüt`}
                  >
                    <div className="certificate-image-area">
                      <img
                        src={certificate.image}
                        alt={certificate.title}
                        loading="lazy"
                        onError={(event) => {
                          console.error(
                            "SERTIFIKA_GORSELI_YUKLENEMEDI:",
                            event.currentTarget.src,
                          );
                        }}
                      />
                    </div>
                  </button>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      {selectedCertificate && (
        <div
          className="certificate-modal"
          role="dialog"
          aria-modal="true"
          aria-label={selectedCertificate.title}
          onClick={() => setSelectedCertificate(null)}
        >
          <div
            className="certificate-modal-content"
            onClick={(event) => {
              if (event.target === event.currentTarget) {
                setSelectedCertificate(null);
              }
            }}
          >
            <div className="certificate-modal-actions">
              {/* KAPAT */}
              <button
                type="button"
                className="certificate-modal-close"
                onClick={() => setSelectedCertificate(null)}
                aria-label="Sertifikayı kapat"
                title="Kapat"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M6 6l12 12" />
                  <path d="M18 6L6 18" />
                </svg>
              </button>
            </div>

            <img
              className="certificate-modal-image"
              src={selectedCertificate.image}
              alt={selectedCertificate.title}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default BlogOne;
